
import type { PropOptions } from 'vue';
import Vue from 'vue';
import BravadoLogoIcon from './images/bravado-logo.vue.svg';
import WarRoomPostActions from '@/components/partials/war-room/WarRoomPostActions.vue';
import type { IPost } from '@/types/community';

export default Vue.extend({
  name: 'WarRoomPostOfficialHeader',
  components: {
    WarRoomPostActions,
    BravadoLogoIcon,
  },
  props: {
    post: {
      type: Object,
      required: true,
    } as PropOptions<IPost>,
  },
});
